import { useState } from 'react';
import { namedOperations, useUpdateGeminiThreadNameMutation } from '@anytag/graphql';
import { useQueryHelper } from '@anytag/shared-hooks';
import { EditingChatNameState } from '../types';

export const useEditingHistoryName = () => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const [editingName, setEditingName] = useState<EditingChatNameState>(initialEditingNameState);
  const { callUpdateGeminiThreadName } = useUpdateGeminiThreadNameMutation({
    refetchQueries: [namedOperations.Query.GeminiChats]
  });

  const handleUpdateName = async () => {
    if (!editingName.id || !editingName.value) return;

    try {
      setEditingName((prev) => ({
        ...prev,
        isSubmitting: true
      }));
      await callUpdateGeminiThreadName({ variables: { input: { id: editingName.id, name: editingName.value } } });
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    } finally {
      setEditingName(initialEditingNameState);
    }
  };

  return { editingName, setEditingName, handleUpdateName };
};

export const initialEditingNameState: EditingChatNameState = {
  id: null,
  value: null,
  isEditing: false,
  isSubmitting: false
};
